import { ActionContext, Module } from 'vuex'
import { OAuthClientApp, RootState } from './state_models'


export const oauth_client_app: Module<OAuthClientApp, RootState> = {
  namespaced: true,
  state: {
    app: undefined
   },
  getters: {
    getApp: (state) => {
      return state.app
    }
  },
  mutations: {
    set: (
      state:OAuthClientApp,
      payload: any
    ) => {
        state.app = payload
      
    },
    clear:(state: OAuthClientApp) =>{
        state.app = {}
    }
  },
  actions: {
    get: (context: ActionContext<OAuthClientApp, RootState>) => {
      return new Promise((resolve, reject) => {
        if (context.state.app) {
          return resolve(context.state.app)
        }
        return resolve(undefined)
      })
    },
    set: (context: ActionContext<OAuthClientApp, RootState>, payload: OAuthClientApp) => {
      context.commit('set', payload)     
    },
    
  }
}
